/**
 * The Texts used in this application
 */
class Texts {
    static serverErrorTitle: string = 'Error';
    static serverErrorMessage: string = 'Can not communicate with the servers properly, please try again later.';
    static serverSuccessTitle: string = 'Success';
    static serverSuccessMessage: string = 'Your request completed successfully';

    // Importing file error messages
    static partIdsNotFound: string = "No valid Parts found. Please check your data and try again.";
    static technicalPropertiesNotFound: string = "Cannot fetch the technical properties for products in the system";
    static tagsInfoNotFound: string = "Cannot fetch the specified tags information in the system";
    static invalidRecordInTheList: string = 'Invalid Record Found in the list';
    static invalidData: string = "The data was invalid";
    static nothingToChange: string = "Your data does not need to change as your request is already up to date";
    static inventoryAdjustmentReasonsEmpty: string = "Inventory adjustment reasons are empty in the system. Pleas add inventory" +
        " adjustment reason in the system before proceeding";
    static somethingWentWrong: string = "Something went wrong. Please try again later.";
}


export default Texts;
